import React, { useState, useEffect } from "react";
import {
  Box,
  Avatar,
  IconButton,
  Modal,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
} from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import styled from "styled-components";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import JsonData from "../../../Data/data.Url.json";
import TeamList from "./TeamList";
import { EasyToastify, ToastContainer } from "../../../Extentions/EasyToastify";
import { tokens } from "../../../theme";

const StyledAccordion = styled(Accordion)`
  border-radius: 16px;
  padding: 16px;
`;

const StyledMemberBox = styled(Box)`
  position: relative;

  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 40px;
    color: #042045;
    background-color: #f44336;
    padding: 3px;
    border-radius: 30px;
    display: flex;
  }
`;

const StyledModalInputBox = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 640px;
  background-color: #010c20;
  border: 1px solid #fff;
  border-radius: 20px;
  box-shadow: 24px;
  padding: 32px;

  @media only screen and (max-width: 480px) {
    padding: 12px;
    width: 320px;
  }

  input {
    padding: 4px 10px;
    border: none;
    border-radius: 4px;

    :focus {
      outline: none;
    }
  }
`;

const SettingsOrgInviteTeam = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const axiosPrivate = useAxiosPrivate();

  const [teamList, setTeamList] = useState("");
  const [query, setQuery] = useState("");
  const [renderTeams, setRenderTeams] = useState(false);

  useEffect(() => {
    if (renderTeams && query !== "") {
      const fetchData = async () => {
        const response = await axiosPrivate.get(
          `team/Get/MinimalTeams/${query}`
        );
        setTeamList(response.data);
      };
      const timeOutId = setTimeout(() => fetchData(), 1000);
      return () => clearTimeout(timeOutId);
    }
  }, [query]);

  const handleTeamInvite = async (id) => {
    if (teamList) {
      await axiosPrivate
        .post(`Organisation/Invite/team?id=${id}`)
        .then((res) => {
          EasyToastify.ToastSuccess("Invitation Sent");
          setOpen(false);
        })
        .catch((error) => {
          EasyToastify.ToastError("Oop Something wrong!");
        });
    }
  };

  return (
    <StyledAccordion
      defaultExpanded={true}
      disableGutters={true}
      sx={{
        backgroundColor: "transparent",
        "&:before": { display: "none" },
      }}
      style={{ backgroundColor: colors.greenAccent[800] }}
      elevation={0}
      square={true}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2a-content"
        id="panel2a-header"
      >
        <Typography>Remove or add Teams:</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TeamList />
        <Box padding="8px">
          <p>Add Teams:</p>
          <Box display="flex" gap="16px" paddingTop="12px">
            <IconButton
              onClick={handleOpen}
              sx={{ border: 1, borderColor: "#313b4f" }}
            >
              <GroupAddIcon sx={{ width: 45, height: 45 }} />
            </IconButton>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <StyledModalInputBox>
                <input
                  type="text"
                  value={query}
                  onChange={(event) => {
                    setQuery(event.target.value);
                    setRenderTeams(true);
                  }}
                />
                {teamList
                  ? teamList.map((items, index) => (
                      <Box
                        key={index}
                        display="flex"
                        justifyContent="space-between"
                        padding="4px 16px"
                      >
                        <Box display="flex" alignItems="center" gap="12px">
                          {items.imgUrl ? (
                            <Avatar
                              src={
                                JsonData.imgurl +
                                items.imgUrl.replace("\\\\", "\\")
                              }
                              alt=""
                            />
                          ) : (
                            <Avatar />
                          )}
                          <p>{items.name}</p>
                        </Box>
                        <Button
                          onClick={() => handleTeamInvite(items.id)}
                          variant="contained"
                          color="secondary"
                        >
                          Invite
                        </Button>
                      </Box>
                    ))
                  : ""}
              </StyledModalInputBox>
            </Modal>
            <ToastContainer />
          </Box>
        </Box>
      </AccordionDetails>
    </StyledAccordion>
  );
};

export default SettingsOrgInviteTeam;
